// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"df4bdc17","513":"e23f2ba5","703":"14022147","787":"741410f6"}[chunkId] + ".chunk.js";
};